/**
 * Mapbox GL JS — cheap entry shim only (no eager mapbox-gl import).
 * Map components import mapbox-gl lazily and set accessToken there.
 * If something has already attached mapboxgl to window, set the token when possible.
 */

import { config } from '@config/env';

if (typeof window !== 'undefined' && config.MAPBOX_TOKEN) {
  if (window.mapboxgl) {
    try {
      window.mapboxgl.accessToken = config.MAPBOX_TOKEN;
    } catch (e) {
      // Ignore if frozen
    }
  }
}

export default {};

